<template>
  <div class="smallchallenge-page">
    <div v-loading="loading">
      <main>
        <!-- 轮播 -->
        <div class="swiper">
          <div class="swiperBox" id="swiper">
            <el-carousel :height="swiperHeight">
              <el-carousel-item v-for="(item, index) in ppttrack" :key="index">
                <template v-if="item.type == 2">
                  <a :href="item.url" target="_blank">
                    <img
                      class="bannImage"
                      :src="item.image"
                      alt=""
                      @click="addUrl(item)"
                    />
                  </a>
                </template>
                <template v-else>
                  <img
                    class="bannImage"
                    :src="item.image"
                    alt=""
                    @click="addUrl(item)"
                  />
                </template>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

        <!-- 小挑模块内容区域 - 统一外层包裹 -->
        <div class="smallchallenge-content-wrapper">
          <!-- 小挑模块标题 -->
          <div class="smallchallenge-title-section">
            <div class="smallchallenge-title-header">
              <div class="title-icon-wrapper">
                <i class="el-icon-s-finance title-icon"></i>
              </div>
              <h2>挑战杯大学生创业计划竞赛</h2>
              <p class="title-subtitle">创业梦想 · 成就未来</p>
              <div class="title-decoration">
                <span class="decoration-line"></span>
                <span class="decoration-dot"></span>
                <span class="decoration-line"></span>
              </div>
            </div>
          </div>

          <!-- 竞赛组别模块 -->
        <div class="smallchallenge-modules">
          <div class="module-section competition-section">
            <div class="module-header-wrapper">
              <div class="module-header">
                <div class="module-title-group">
                  <div class="module-icon">
                    <i class="el-icon-s-finance"></i>
                  </div>
                  <div class="module-title-content">
                    <h2>竞赛组别</h2>
                    <p>COMPETITION CATEGORIES</p>
                  </div>
                </div>
                <div class="module-description">
                  <p>聚焦五大核心赛道，助力创业项目脱颖而出</p>
                </div>
              </div>
              <div class="category-tabs">
                <div
                  :class="[
                    'category-tab',
                    { active: selectedCategory === 'all' }
                  ]"
                  @click="selectCategory('all')"
                >
                  全部
                </div>
                <div
                  v-for="category in categories"
                  :key="category.id"
                  :class="[
                    'category-tab',
                    { active: selectedCategory === category.id }
                  ]"
                  @click="selectCategory(category.id)"
                >
                  {{ category.name }}
                </div>
              </div>
            </div>
            <div class="files-grid" v-if="files.length > 0">
              <div
                v-for="file in files"
                :key="file.id"
                class="file-card"
                @click="viewFile(file)"
              >
                <div class="file-image">
                  <img 
                    v-if="file.cover || file.image" 
                    :src="file.cover || file.image" 
                    :alt="file.name" 
                    @error="handleImageError"
                  />
                  <div v-else class="image-placeholder">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <i class="ppt_tag-vip ppt_tag-vips"></i>
                </div>
                <div class="file-info">
                  <div class="file-tags" v-if="file.tag">
                    <span
                      v-for="(tag, index) in file.tag.split(',')"
                      :key="index"
                      class="file-tag"
                    >
                      {{ tag }}
                    </span>
                  </div>
                  <div class="file-content">
                    <div class="file-left">
                      <h3>{{ file.name }}</h3>
                    </div>
                    <div class="file-right">
                      <div class="file-stats">
                        <span class="stat-item">
                          <i class="iconfont iconaixin"></i>
                          {{ file.laud || 0 }}
                        </span>
                        <span class="stat-item">
                          <i class="iconfont iconai-eye"></i>
                          {{ file.pv || 0 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty-state" v-else>
              <div class="empty-icon">
                <i class="el-icon-document"></i>
              </div>
              <p>暂无文件数据</p>
            </div>
            <!-- 分页 -->
            <div class="pagination-container">
              <el-pagination
                @current-change="handlePageChange"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total || 0"
                layout="prev, pager, next"
                :pager-count="5"
                :hide-on-single-page="false"
                prev-text="上一页"
                next-text="下一页"
                background
              >
              </el-pagination>
            </div>
          </div>
        </div>
        </div>

        <!-- 用户评价轮播区域 -->
        <div class="reviews-section">
          <div class="reviews-container">
            <div class="reviews-header">
              <h2>用户评价</h2>
              <p>USER REVIEWS</p>
            </div>
            <div class="reviews-content">
              <vue-seamless-scroll
                :data="reviewData1"
                :class-option="reviewOption1"
                ref="reviewScroll1"
                class="review-scroll"
              >
                <ul>
                  <li
                    class="review-item"
                    v-for="(item, index) in reviewData1"
                    :key="'r1' + index"
                  >
                    <div class="review-avatar">
                      <img :src="item.avatar" alt="" />
                    </div>
                    <div class="review-content">
                      <div class="review-text">{{ item.content }}</div>
                      <div class="review-user">{{ item.username }}</div>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
              <vue-seamless-scroll
                :data="reviewData2"
                :class-option="reviewOption2"
                ref="reviewScroll2"
                class="review-scroll"
              >
                <ul>
                  <li
                    class="review-item"
                    v-for="(item, index) in reviewData2"
                    :key="'r2' + index"
                  >
                    <div class="review-avatar">
                      <img :src="item.avatar" alt="" />
                    </div>
                    <div class="review-content">
                      <div class="review-text">{{ item.content }}</div>
                      <div class="review-user">{{ item.username }}</div>
                    </div>
                  </li>
                </ul>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>

        <!-- 服务保障区域 -->
        <div class="itmentBox">
          <ul class="tment_ul clearfix">
            <li>
              <i class="iconfont iconbanquan"></i>
              <p class="decla_title">正版承诺</p>
              <p class="decla_intro">拒绝盗版，获设计师独家授权</p>
            </li>
            <li>
              <i class="iconfont iconbanquan1"></i>
              <p class="decla_title">版权保障 商用无忧</p>
              <p class="decla_intro">对全站所有模板均拥有商用授权</p>
            </li>
            <li class="last_item">
              <i class="iconfont icontiexinfuwu"></i>
              <p class="decla_title">全天候 贴心服务</p>
              <p class="decla_intro">
                发票支持，报销无忧<br />团队协作，院校会员可多人使用
              </p>
            </li>
          </ul>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import API from "@/api/api";

export default {
  name: "SmallChallengePage",
  data() {
    return {
      ppttrack: [],
      screenWidth: document.body.clientWidth,
      swiperHeight: "625px",
      loading: false,

      // 用户评价数据
      reviewData1: [],
      reviewData2: [],

      // 分页
      pageSize: 8,

      // 竞赛组别数据
      categories: [],
      files: [],
      pageNum: 1,
      total: 0,
      selectedCategory: null
    };
  },
  computed: {
    ...mapState(["nav"]),
    reviewOption1() {
      return {
        step: 0.8,
        limitMoveNum: 0,
        hoverStop: true,
        direction: 2,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1500
      };
    },
    reviewOption2() {
      return {
        step: 0.8,
        limitMoveNum: 0,
        hoverStop: true,
        direction: 3,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 1500
      };
    }
  },
  methods: {
    // 加载初始数据
    async loadInitialData() {
      this.loading = true;
      try {
        // 加载分类数据（使用假数据）
        await this.loadCategories();
        // 加载文件数据（使用假数据）
        await this.loadFiles();
      } catch (error) {
        this.$message.error('数据加载失败，请刷新页面重试');
      } finally {
        this.loading = false;
      }
    },

    // 加载分类数据
    async loadCategories() {
      try {
        const response = await API.xiaotiaoIndex({});

        if (response && response.data && (response.data.code === 200 || response.data.success === true)) {
          // 根据文档，竞赛组别分类使用tag=9
          this.categories = response.data.data || [];
        } else {
          // 降级到假数据
          this.categories = [
            { id: 2001, name: '科技创新和未来产业' },
            { id: 2002, name: '乡村振兴和农业农村现代化' },
            { id: 2003, name: '城市治理和社会服务' },
            { id: 2004, name: '生态环保和可持续发展' },
            { id: 2005, name: '文化创意和区域合作' }
          ];
        }
      } catch (error) {
        // 降级到假数据
        this.categories = [
          { id: 2001, name: '科技创新和未来产业' },
          { id: 2002, name: '乡村振兴和农业农村现代化' },
          { id: 2003, name: '城市治理和社会服务' },
          { id: 2004, name: '生态环保和可持续发展' },
          { id: 2005, name: '文化创意和区域合作' }
        ];
      }
      this.selectedCategory = 'all';
    },

    // 加载文件数据
    async loadFiles() {
      try {
        const params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        };

        // 根据API文档，id参数必填，0表示查询全部
        if (this.selectedCategory === 'all') {
          params.id = 0; // 0表示查询全部
        } else {
          params.id = this.selectedCategory; // 具体的分类ID
        }

        const response = await API.xiaotiaoPage(params);

        if (response && response.data && (response.data.code === 200 || response.data.success === true)) {
          this.files = response.data.data.records || [];
          this.total = response.data.data.total || 0;
        } else {
          this.files = [];
          this.total = 0;
        }
      } catch (error) {
        this.files = [];
        this.total = 0;
      }
    },

    // 选择分类
    async selectCategory(categoryId) {
      this.selectedCategory = categoryId;
      this.pageNum = 1;
      await this.loadFiles();
    },

    // 处理图片加载错误
    handleImageError(event) {
      const img = event.target;
      const placeholder = document.createElement('div');
      placeholder.className = 'image-placeholder';
      placeholder.innerHTML = '<i class="el-icon-picture-outline"></i>';
      img.parentNode.replaceChild(placeholder, img);
    },

    // 查看文件详情
    viewFile(file) {
      // 跳转到小挑详情页
      const link = this.$router.resolve({
        name: "SmallChallengeDetail",
        query: { 
          code: file.code
        }
      });
      window.open(link.href, "_blank");
    },

    // 获取轮播图
    async getSwiperData() {
      try {
        const response = await API.xiaotiaoIndexAd({});

        // 后端返回格式: {data: {success: true, code: 200, message: "操作成功", data: [], timestamp: "..."}}
        if (response && response.data && (response.data.code === 200 || response.data.success === true) && response.data.data && response.data.data.length > 0) {
          this.ppttrack = response.data.data || [];
        } else {
          // 如果没有轮播图数据，使用默认图片
          this.ppttrack = [
            {
              id: 1,
              image: 'https://static.ibeisai.com/image/20200507/banner2256.jpg',
              type: 1
            },
            {
              id: 2,
              image: 'https://rselect1.oss-cn-beijing.aliyuncs.com/image/20200507/03.png',
              type: 1
            }
          ];
        }
      } catch (error) {
        // 使用默认图片
        this.ppttrack = [
          {
            id: 1,
            image: 'https://static.ibeisai.com/image/20200507/banner2256.jpg',
            type: 1
          },
          {
            id: 2,
            image: 'https://rselect1.oss-cn-beijing.aliyuncs.com/image/20200507/03.png',
            type: 1
          }
        ];
      }
    },

    // 获取用户评价数据
    async getReviewData() {
      try {
        const response = await API.xiaotiaoIndexMsg({});

        if (response && response.data && (response.data.code === 200 || response.data.success === true)) {
          // 根据文档，用户评价分3组（s1, s2, s3），这里使用前两组
          this.reviewData1 = response.data.data.s1 || [];
          this.reviewData2 = response.data.data.s2 || [];
        } else {
          // 降级到假数据
          this.reviewData1 = [
            {
              avatar: require('@/assets/人像.png'),
              content: '小挑的模板非常专业，帮助我们的创业项目获得了省赛一等奖！',
              username: '张同学'
            },
            {
              avatar: require('@/assets/人像.png'),
              content: '模板质量很高，内容结构清晰，非常适合创业计划竞赛使用。',
              username: '李同学'
            },
            {
              avatar: require('@/assets/人像.png'),
              content: '小挑的素材库真的很全面，从科技创新到乡村振兴都有覆盖。',
              username: '王同学'
            }
          ];

          this.reviewData2 = [
            {
              avatar: require('@/assets/人像.png'),
              content: '专项赛的模板特别实用，帮助我们快速完成了项目计划书。',
              username: '赵同学'
            },
            {
              avatar: require('@/assets/人像.png'),
              content: '价格合理，质量优秀，值得推荐给所有参加小挑的同学！',
              username: '刘同学'
            },
            {
              avatar: require('@/assets/人像.png'),
              content: '模板设计精美，内容专业，大大提升了我们的项目展示效果。',
              username: '陈同学'
            }
          ];
        }
      } catch (error) {
        // 降级到假数据
        this.reviewData1 = [
          {
            avatar: require('@/assets/人像.png'),
            content: '小挑的模板非常专业，帮助我们的创业项目获得了省赛一等奖！',
            username: '张同学'
          },
          {
            avatar: require('@/assets/人像.png'),
            content: '模板质量很高，内容结构清晰，非常适合创业计划竞赛使用。',
            username: '李同学'
          },
          {
            avatar: require('@/assets/人像.png'),
            content: '小挑的素材库真的很全面，从科技创新到乡村振兴都有覆盖。',
            username: '王同学'
          }
        ];

        this.reviewData2 = [
          {
            avatar: require('@/assets/人像.png'),
            content: '专项赛的模板特别实用，帮助我们快速完成了项目计划书。',
            username: '赵同学'
          },
          {
            avatar: require('@/assets/人像.png'),
            content: '价格合理，质量优秀，值得推荐给所有参加小挑的同学！',
            username: '刘同学'
          },
          {
            avatar: require('@/assets/人像.png'),
            content: '模板设计精美，内容专业，大大提升了我们的项目展示效果。',
            username: '陈同学'
          }
        ];
      }

      this.$nextTick(() => {
        this.$refs.reviewScroll1 && this.$refs.reviewScroll1.reset();
        this.$refs.reviewScroll2 && this.$refs.reviewScroll2.reset();
      });
    },

    // 轮播图相关方法
    addUrl(item) {
      // 处理轮播图点击事件
    },

    // 分页处理
    async handlePageChange(page) {
      this.pageNum = page;
      await this.loadFiles();
    },

    ...mapMutations(["UP_BOOLE"])
  },

  watch: {
    screenWidth(val) {
      // 屏幕宽度变化处理
    }
  },

  async mounted() {
    this.UP_BOOLE();
    await this.getSwiperData();
    await this.getReviewData();
    await this.loadInitialData();

    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  }
};
</script>

<style scoped>
.smallchallenge-page {
  min-height: 100vh;
  background: #fefefe;
  position: relative;
}

.smallchallenge-page > div {
  position: relative;
  z-index: 1;
}

/* 轮播图样式 */
.swiper {
  position: relative;
  margin-bottom: 40px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.swiper img {
  width: 100%;
  height: 625px;
  object-fit: cover;
}

.swiperBox .el-carousel__indicators {
  opacity: 0;
}

.swiperBox .el-carousel {
  width: 100%;
  overflow: hidden;
}

.swiperBox .el-carousel__container {
  width: 100%;
  overflow: hidden;
}

.swiperBox .el-carousel__item {
  overflow: hidden;
}

/* 小挑模块标题区域样式 - 商务正式风格 */
.smallchallenge-title-section {
  max-width: 1400px;
  margin: 40px auto 30px;
  padding: 0 32px;
}

.smallchallenge-title-header {
  text-align: center;
  padding: 40px 32px 32px;
  background: #ffffff;
  border-radius: 0;
  box-shadow: none;
  border: none;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid #f0f2f5;
}

.title-icon-wrapper {
  margin-bottom: 20px;
}

.title-icon {
  font-size: 48px;
  color: #ff9800;
  display: inline-block;
  padding: 16px;
  background: #fff8e1;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  line-height: 16px;
  box-sizing: border-box;
}

.smallchallenge-title-header h2 {
  font-size: 32px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 16px 0;
  letter-spacing: 0.5px;
  line-height: 1.3;
}

.smallchallenge-title-header .title-subtitle {
  font-size: 18px;
  color: #78909c;
  margin: 0 0 32px 0;
  font-weight: 500;
  letter-spacing: 1px;
}

.title-decoration {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 32px;
}

.decoration-line {
  width: 60px;
  height: 2px;
  background: #ffc107;
  opacity: 0.5;
}

.decoration-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffc107;
  box-shadow: 0 0 8px rgba(255, 193, 7, 0.5);
}

/* 小挑模块样式 - 商务正式风格 */
.smallchallenge-content-wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px 40px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin-top: -30px;
  position: relative;
  z-index: 2;
  border: 1px solid #e8eaed;
}

.smallchallenge-modules {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0;
}

.module-section {
  background: #ffffff;
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 0;
  padding: 0;
  overflow: hidden;
  border: none;
  border-bottom: 1px solid #f0f2f5;
}

.module-section:last-child {
  border-bottom: none;
}

.module-header-wrapper {
  background: #fafbfc;
  border-bottom: 1px solid #f0f2f5;
  position: relative;
  padding: 0 32px;
}

.module-header {
  text-align: center;
  padding: 24px 0 16px;
}

.module-title-group {
  display: inline-block;
  position: relative;
}

.module-header h2 {
  font-size: 22px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 4px 0;
}

.module-header p {
  font-size: 11px;
  color: #95a5a6;
  margin: 0;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-weight: 400;
}

.module-description {
  margin-top: 12px;
}

.module-description p {
  font-size: 14px;
  color: #78909c;
  margin: 0;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}

/* 分类标签样式 - 商务按钮风格 */
.category-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 0 16px;
  background: #fafbfc;
  justify-content: center;
  margin: 0 32px;
}

.category-tab {
  padding: 8px 20px;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  color: #5f6c7b;
}

.category-tab:hover {
  background: #fffbf0;
  border-color: #ffc107;
  color: #ff9800;
}

.category-tab.active {
  background: #fff8e1;
  border-color: #ffc107;
  color: #ff9800;
  font-weight: 500;
}

/* 文件网格样式 - 商务卡片风格 */
.files-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin: 24px 32px;
  padding: 0;
}

.file-card {
  background: #ffffff;
  border: 1px solid #f0f2f5;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  position: relative;
}

.file-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: transparent;
  transition: background 0.3s ease;
}

.file-card:hover::before {
  background: #ffc107;
}

.file-card:hover {
  border-color: #ffc107;
  box-shadow: 0 4px 12px rgba(255, 193, 7, 0.15);
  transform: translateY(-2px);
}

.file-image {
  width: 100%;
  height: 180px;
  overflow: hidden;
  position: relative;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f8f9fa;
}

.file-image .ppt_tag-vip {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  background: url('../../assets/vipimage.png') no-repeat center;
  background-size: contain;
  z-index: 1;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  color: #cbd5e1;
}

.image-placeholder i {
  font-size: 48px;
  color: #bdbdbd;
}

.file-info {
  padding: 10px 16px;
}

.file-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.file-tag {
  font-size: 11px;
  color: #546e7a;
  background: #f5f5f5;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  font-weight: 500;
  transition: all 0.2s ease;
}

.file-card:hover .file-tag {
  background: #fffef5;
  border-color: #ffd54f;
  color: #ffb74d;
}

.file-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.file-left {
  flex: 1;
  min-width: 0;
}

.file-right {
  flex-shrink: 0;
}

.file-info h3 {
  font-size: 16px;
  font-weight: 600;
  color: #37474f;
  margin: 0;
  line-height: 1.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s ease;
}

.file-card:hover .file-info h3 {
  color: #ffb74d;
}

.file-stats {
  display: flex;
  gap: 16px;
  align-items: center;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #78909c;
  white-space: nowrap;
  font-weight: 500;
  transition: color 0.3s ease;
}

.stat-item i {
  font-size: 15px;
  color: #ffb74d;
}

.file-card:hover .stat-item {
  color: #ffb74d;
}


/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  background: #fafbfc;
  border-radius: 0;
  margin: 0;
}

.empty-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8eaed;
  border-radius: 50%;
}

.empty-icon i {
  font-size: 40px;
  color: #94a3b8;
}

.empty-state p {
  color: #94a3b8;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 20px 32px 30px;
  border-top: 1px solid #f0f2f5;
}

/* 用户评价轮播区域样式 - 简约风格 */
.reviews-section {
  background: #ffffff;
  padding: 60px 0;
  margin-top: 30px;
  border-top: 1px solid #f0f2f5;
}

.reviews-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.reviews-header {
  text-align: center;
  margin-bottom: 40px;
}

.reviews-header h2 {
  font-size: 26px;
  font-weight: 500;
  color: #2c3e50;
  margin: 0 0 8px 0;
}

.reviews-header p {
  font-size: 12px;
  color: #95a5a6;
  margin: 0;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-weight: 400;
}

.reviews-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.review-scroll {
  height: 120px;
  overflow: hidden;
  position: relative;
}

.review-scroll ul {
  display: flex;
  align-items: center;
  height: 100%;
}

.review-item {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background: #fafbfc;
  border-radius: 8px;
  margin-right: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
  white-space: nowrap;
  min-width: 400px;
  border-left: 3px solid #cbd5e1;
  flex-shrink: 0;
}

.review-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-left-color: #93c5fd;
}

.review-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;
  border: 2px solid #e8eaed;
}

.review-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.review-content {
  flex: 1;
}

.review-text {
  font-size: 15px;
  color: #475569;
  line-height: 1.5;
  margin-bottom: 6px;
  font-weight: 400;
}

.review-user {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

/* 服务保障区域样式 - 简约风格 */
.itmentBox {
  width: 100%;
  background: #fafbfc;
  border-top: 1px solid #f0f2f5;
  padding: 50px 0;
}

.tment_ul {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  padding: 0 20px;
}

.tment_ul li {
  flex: 1;
  max-width: 350px;
  padding: 40px 30px;
  box-sizing: border-box;
  text-align: center;
  position: relative;
}

.tment_ul li i {
  font-size: 64px;
  line-height: 1;
  height: 64px;
  margin-bottom: 24px;
  color: #2FA4F5;
  display: block;
  transition: color 0.3s ease;
}


.decla_title {
  font-size: 18px;
  color: #2c3e50;
  height: 28px;
  line-height: 28px;
  margin-bottom: 12px;
  font-weight: 500;
}

.decla_intro {
  font-size: 14px;
  color: #64748b;
  line-height: 24px;
  font-weight: 400;
}

.tment_ul li::after {
  content: '';
  width: 1px;
  height: 120px;
  display: block;
  background: #e8eaed;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.tment_ul li.last_item::after {
  display: none;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .files-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
  }
}

@media (max-width: 768px) {
  .smallchallenge-content-wrapper {
    padding: 0 16px 30px;
    margin-top: -20px;
    border-radius: 6px;
  }

  .smallchallenge-title-section {
    margin: 30px auto 20px;
    padding: 0 16px;
  }

  .smallchallenge-title-header {
    padding: 30px 20px 24px;
  }

  .title-icon {
    font-size: 40px;
    width: 70px;
    height: 70px;
    line-height: 8px;
    padding: 14px;
  }

  .smallchallenge-title-header h2 {
    font-size: 22px;
    letter-spacing: 0.5px;
  }

  .smallchallenge-title-header .title-subtitle {
    font-size: 13px;
    letter-spacing: 1.5px;
  }

  .module-section {
    margin-bottom: 0;
  }

  .module-header {
    padding: 20px 20px 12px;
  }

  .module-header h2 {
    font-size: 18px;
  }

  .category-tabs {
    padding: 0 0 12px;
    gap: 6px;
    margin: 0 20px;
  }

  .category-tab {
    padding: 6px 16px;
    font-size: 12px;
  }

  .files-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    margin: 20px 20px;
  }

  .file-image {
    height: 140px;
  }

  .swiper img {
    height: 300px;
  }

  .pagination-container {
    margin: 20px 0;
    padding: 20px 0;
  }

  .reviews-section {
    padding: 40px 0;
    margin-top: 40px;
  }

  .reviews-header h2 {
    font-size: 22px;
  }

  .review-item {
    min-width: 300px;
    padding: 14px 20px;
  }

  .review-avatar {
    width: 44px;
    height: 44px;
    margin-right: 14px;
  }

  .review-text {
    font-size: 14px;
  }

  .review-user {
    font-size: 12px;
  }

  .tment_ul {
    flex-direction: column;
    align-items: center;
    gap: 0;
  }

  .tment_ul li {
    width: 100%;
    max-width: 100%;
    padding: 35px 25px;
    margin-bottom: 0;
  }

  .tment_ul li i {
    font-size: 56px;
    height: 56px;
    margin-bottom: 20px;
  }

  .decla_title {
    font-size: 17px;
    margin-bottom: 10px;
  }

  .decla_intro {
    font-size: 13px;
  }

  .tment_ul li::after {
    display: none;
  }
}

@media (max-width: 480px) {
  .smallchallenge-title-section {
    margin: 30px auto 25px;
    padding: 0 12px;
  }

  .smallchallenge-title-header {
    padding: 30px 20px;
  }

  .smallchallenge-title-header h2 {
    font-size: 22px;
    letter-spacing: 0;
  }

  .smallchallenge-title-header .title-subtitle {
    font-size: 13px;
    letter-spacing: 1px;
  }

  .files-grid {
    grid-template-columns: 1fr;
    gap: 16px;
    margin: 20px 16px;
  }

  .category-tab {
    padding: 6px 14px;
    font-size: 11px;
  }

  .module-header {
    padding: 20px 16px 14px;
  }

  .module-header h2 {
    font-size: 18px;
  }

  .pagination-container {
    margin: 16px 0;
    padding: 16px 0;
  }
}
</style>

